// Traducciones repartidas por dominio (Fase 0 / PR 0.3).
//
// Antes eran dos ficheros de ~9.200 líneas —`locales/es.json` y `locales/en.json`—
// que concentraban el 39% de los cambios del frontend: cualquier par de ramas que
// tocara texto colisionaba en el mismo sitio.
//
// El reparto NO renombra ninguna clave: solo distribuye las de primer nivel por
// dominio. Todo se fusiona aquí en un único objeto, que `index.js` registra como
// el namespace `translation` de siempre — así `t('invoices.title')` sigue
// resolviendo igual y ningún componente cambia.
//
// Este módulo NO inicializa i18next a propósito: los tests de paridad de claves
// lo importan y no deben arrastrar i18next ni `safeStorage`.
//
// Deliberadamente NO hay lazy load por feature todavía: cargar un namespace tarde
// hace que un `t()` anterior renderice la clave cruda, y la Fase 0 no admite
// cambios de comportamiento. Llega en Fase 2, cuando exista `features/<modulo>/`
// y la carga pueda atarse al montaje del módulo.
//
// Para añadir un dominio: crea `locales/<idioma>/<dominio>.json` y añádelo abajo.
// El test `localeSplit` verifica que ningún fichero quede sin importar y que dos
// dominios no declaren la misma clave de primer nivel.
import esAccounting from './locales/es/accounting.json';
import esAi from './locales/es/ai.json';
import esBanking from './locales/es/banking.json';
import esBilling from './locales/es/billing.json';
import esCommon from './locales/es/common.json';
import esFiscal from './locales/es/fiscal.json';
import esHr from './locales/es/hr.json';
import esOperations from './locales/es/operations.json';

import enAccounting from './locales/en/accounting.json';
import enAi from './locales/en/ai.json';
import enBanking from './locales/en/banking.json';
import enBilling from './locales/en/billing.json';
import enCommon from './locales/en/common.json';
import enFiscal from './locales/en/fiscal.json';
import enHr from './locales/en/hr.json';
import enOperations from './locales/en/operations.json';

export const es = {
  ...esCommon,
  ...esAccounting,
  ...esAi,
  ...esBanking,
  ...esBilling,
  ...esFiscal,
  ...esHr,
  ...esOperations,
};

export const en = {
  ...enCommon,
  ...enAccounting,
  ...enAi,
  ...enBanking,
  ...enBilling,
  ...enFiscal,
  ...enHr,
  ...enOperations,
};
